export const initCustomPinClasses = () => {
  if (!window.Acr?.MapPushpinClasses) {
    class MapPushpin {
      location: any;
      anchor: any;
      metadata: any | null;
      _element: HTMLDivElement;

      constructor(loc: any, html: string, anchor: any) {
        this.location = loc;
        this.anchor = anchor;
        this.metadata = null;

        // Create the pushpins DOM element.
        this._element = document.createElement('div');
        this._element.innerHTML = html;
        this._element.style.position = 'absolute';
      }
    }

    class MapPushpinLayer extends window.Microsoft.Maps.CustomOverlay {
      private _pushpins: MapPushpin[] | null;
      private viewChangeEventHandler: any;
      private container: HTMLDivElement | null;

      constructor() {
        super({ beneathLabels: false });

        this._pushpins = null;
        this.viewChangeEventHandler = null;
        this.container = null;
      }

      setPushpins(pushpins: MapPushpin[]) {
        this._pushpins = pushpins;

        if (this.container) {
          this.container.innerHTML = '';

          if (pushpins) {
            for (let i = 0, len = pushpins.length; i < len; i++) {
              this.container.appendChild(pushpins[i]._element);
            }
          }
        }

        this.updatePositions();
      }

      private _updatePushpinPosition(pin: MapPushpin) {
        if (this.getMap()) {
          let topLeft = this.getMap().tryLocationToPixel(
            pin.location,
            window.Microsoft.Maps.PixelReference.control
          );

          topLeft.x -= pin.anchor.x;
          topLeft.y -= pin.anchor.y;

          pin._element.style.left = topLeft.x + 'px';
          pin._element.style.top = topLeft.y + 'px';
        }
      }

      updatePositions() {
        if (this._pushpins) {
          for (let i = 0, len = this._pushpins.length; i < len; i++) {
            this._updatePushpinPosition(this._pushpins[i]);
          }
        }
      }

      onAdd() {
        this.container = document.createElement('div');
        this.container.style.position = 'absolute';
        this.container.style.left = '0px';
        this.container.style.top = '0px';

        this.setHtmlElement(this.container);
      }

      onLoad() {
        let self = this;

        self.setPushpins(self._pushpins || []);

        this.viewChangeEventHandler = window.Microsoft.Maps.Events.addHandler(
          self.getMap(),
          'viewchange',
          function () {
            self.updatePositions();
          }
        );
      }

      onRemove() {
        window.Microsoft.Maps.Events.removeHandler(this.viewChangeEventHandler);
      }
    }
    window.Acr.MapPushpinClasses = {
      MapPushpinLayer,
      MapPushpin,
    };
  }

  return window.Acr.MapPushpinClasses;
};
